import authentication from './authentication'
import sellers from './sellers'
import delegations from './delegations'
import sellersTypes from './sellers-types'
import clients from './clients'
import clientsRecords from './clients-records'
import contracts from './contracts'
import contractsHistory from './contractsHistory'
import contractsZips from './contractsZips'
import SDAs from './sda'
import SDAsInfo from './sdas-info'
import reports from './reports'

export default {
	authentication,
	sellers,
	delegations,
	sellersTypes,
	clients,
	clientsRecords,
	contracts,
	contractsHistory,
	contractsZips,
	SDAs,
	SDAsInfo,
	reports
}



// WEBPACK FOOTER //
// ./src/api/api.js